import type { CollaborationMode } from '../../../constants';
import { COLLABORATION_MODE_COLLABORATIVE } from '../../../constants';

export const collaborationModeToCoEdited = (
  collaborationMode: CollaborationMode,
) => {
  return collaborationMode === COLLABORATION_MODE_COLLABORATIVE;
};
